export default [
	{
		image: 'https://images.unsplash.com/photo-1573855619003-97b4799dcd8b?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80',
		title: 'Explore a variety of payment options',
		subtitle: 'Start shopping now'
	},
	{
		image: 'https://images.pexels.com/photos/3762927/pexels-photo-3762927.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
		title: 'Shop wherever you are in Lagos',
		subtitle: 'We will deliver at your door step'
	},
	{
		image: 'https://images.pexels.com/photos/4177710/pexels-photo-4177710.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
		title: 'Buy on credit and payback in installments',
		subtitle: 'Terms and charges apply'
	},
	{
		image: 'https://images.pexels.com/photos/6097887/pexels-photo-6097887.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
		title: 'Fast, Safe & Secure Shopping',
		subtitle: 'Start shopping now'
	},
]
